import connectToStores from 'alt-utils/lib/connectToStores'
import { CheckActions, CheckBlogActions } from 'actions'
import { CheckStore, CheckBlogStore } from 'stores'
import { Setup, NotFoundSetup, SeoProblemsSetup, Loading } from 'components'
import Helmet from 'react-helmet'
import Enum from 'utils/Enum'
import { Analytics } from 'common-frontend'

@connectToStores
export default class SetupContainer extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  }
  static propTypes = {
    params: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      key: ''
    }
  }

  componentWillMount() {
    const key = this.props.params.key.toLowerCase()
    const check = Enum.CheckTypes[key]

    this.setState({ key })

    Analytics.track('Configuring check', {
      advisorType: check.advisorType,
    })

    if (check === Enum.CheckTypes.blog)
       CheckBlogActions.detectBlogUrls()

    if (!this.props.checks || this.props.checks.size === 0)
      CheckActions.fetch()
  }

  componentWillReceiveProps(newProps) {
    if (this.props.checkActivated !== newProps.checkActivated && newProps.checkActivated === true) {
      this.context.router.push(`/checks/${newProps.params.key.toLowerCase()}`)
    } else if (this.props.checkUpdated !== newProps.checkUpdated && newProps.checkUpdated === true) {
      this.context.router.push('/checks') // 'updated' means disabled
    }
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (this.state.currentCheck !== null && prevState.currentCheck == null
  //       || (prevState.currentCheck.get('id') !== this.state.currentCheck.get('id'))) {
  //     this.logAnalytics()
  //   }
  // }

  logAnalytics() {
    // TODO: think about analytics- should it be in containers, actions (probably), router or something else
    // Utils.Analytics.track('Configuring check', {
    //   advisorType: this.state.currentCheck.get('name'),
    // })
  }

  static getStores() {
    return [CheckStore, CheckBlogStore]
  }

  static getPropsFromStores() {
    return {
      ...CheckStore.getState(),
      ...CheckBlogStore.getState()
    }
  }

  renderSetup() {
    const currentCheck = this.props.checks.find(x => x.get('key') === this.state.key)
    const { detectedBlogUrl, detectedFeedUrl } = this.props

    if (this.state.key === Enum.CheckTypes.notfound.key)
      return <NotFoundSetup check={currentCheck} />
    else if (this.state.key === Enum.CheckTypes.seoproblems.key)
      return <SeoProblemsSetup check={currentCheck} />
    else {
      return <Setup
        check={currentCheck}
        detectedBlogUrl={detectedBlogUrl}
        detectedFeedUrl={detectedFeedUrl}
      />
    }
  }

  render() {
    if (!this.props.checks || this.props.checks.size === 0 || this.props.detectingBlogUrls === true)
      return <Loading />

    return this.renderSetup()
  }
}



// WEBPACK FOOTER //
// ./app/containers/SetupContainer.js